import { all } from 'redux-saga/effects';
import getUserPhoneSaga from './get_user_phones.saga';
import createUserPhoneSaga from './create_user_phone.saga';
import changeUserPhoneSaga from './change_user_phone.saga';
import removeUserPhoneSaga from './remove_user_phone.saga';

export default function* userPhonesRootSaga() {
    yield all([
        getUserPhoneSaga(),
        createUserPhoneSaga(),
        changeUserPhoneSaga(),
        removeUserPhoneSaga(),
    ]);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/sagas/user_phones_sagas/phones_root.saga.js